import { IRole } from "../interfaces/IAuditoinnitUser";
import { IAppRoleDTO } from "../interfaces/ICategoryPermission";
import { gateBooleanToBoolean } from "../../sg-core/utils/GateSupport";


export const RoleMapper = {
    apiToDomain: (api: IAppRoleDTO): IRole => ({
        id: api.id,
        name: api.nimi,
        reference: api.viitenimi,
        showNameDetail: gateBooleanToBoolean(api.nayta_nimitiedot)
    }),
};


export default RoleMapper

